var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefCase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74902 23.25H19.249V5.75H17.999V3.875C17.999 3.0462 17.6698 2.25134 17.0837 1.66529C16.4977 1.07924 15.7028 0.75 14.874 0.75H11.124C10.2952 0.75 9.50037 1.07924 8.91431 1.66529C8.32826 2.25134 7.99902 3.0462 7.99902 3.875V5.75H6.74902V23.25ZM10.499 3.875C10.499 3.70924 10.5649 3.55027 10.6821 3.43306C10.7993 3.31585 10.9583 3.25 11.124 3.25H14.874C15.0398 3.25 15.1988 3.31585 15.316 3.43306C15.4332 3.55027 15.499 3.70924 15.499 3.875V5.75H10.499V3.875Z",
    fill: "#2550AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.75V23.25C22.7446 23.25 23.6984 22.8549 24.4017 22.1517C25.1049 21.4484 25.5 20.4946 25.5 19.5V9.5C25.5 8.50544 25.1049 7.55161 24.4017 6.84835C23.6984 6.14509 22.7446 5.75 21.75 5.75Z",
    fill: "#2550AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.75C3.25544 5.75 2.30161 6.14509 1.59835 6.84835C0.895088 7.55161 0.5 8.50544 0.5 9.5V19.5C0.5 20.4946 0.895088 21.4484 1.59835 22.1517C2.30161 22.8549 3.25544 23.25 4.25 23.25V5.75Z",
    fill: "#2550AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefCase);
export default __webpack_public_path__ + "static/media/brief_case.5c260fbe27204429533520f79cc09a4f.svg";
export { ForwardRef as ReactComponent };